import {DomSanitizer} from '@angular/platform-browser';
import { Pipe, inject } from '@angular/core';
import { HtmlSanitizerUtil } from '../../common/html-sanitizer.util';

@Pipe({
    name: "safeHtml",
    standalone: true
})
export class SafeHtmlPipe {
  private sanitizer = inject(DomSanitizer);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  transform(html) {
    // Sanitize HTML before trusting it to prevent XSS
    const cleanedHtml = this.removeCloseButtonfromHtml(html);
    return HtmlSanitizerUtil.sanitizeAndTrustHtml(this.sanitizer, cleanedHtml);
  }

  removeCloseButtonfromHtml(html: string) {
    // Create a temporary div element to hold the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Find the <button.closeElement> element inside the tempDiv
    const buttonElement = tempDiv.querySelectorAll("button.closeButton");

    // Remove the <button.closeButton> element if it exists
    if (buttonElement) {
      buttonElement.forEach((element) => {
        element.parentNode.removeChild(element);
      });
    }

    // Get the updated HTML string from the tempDiv
    return tempDiv.innerHTML.toString();
  }
}
